/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useIsLoggedIn, useSignOut } from 'auth/useAuth';
import { ROUTE_PATHS, isRestrictedRoute, isViewerRoute } from 'app/utils/route';

export function RequireAuth({ children }) {
    const auth = useIsLoggedIn();
    const location = useLocation();
    const signout = useSignOut();
    const { status } = useSelector(state => state.toast);

    if (status === 401) {
        signout();
    }

    if (!auth) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.

        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!auth?.app_type?.includes('APCM')) {
        const viewerRoute = isViewerRoute(location?.pathname);
        let isNavigate = true;
        if (auth?.app_type?.includes("APCM_Executor")) {
            if (location?.pathname.includes('groupid')) {
                isNavigate = false;
            }
        } else if (auth?.app_type?.includes("APCM_Authorizer")) { 
            if (location?.pathname.includes('executorLogsByID')) {
                isNavigate = false;
            }
        }    
        if(viewerRoute || !isNavigate) {
            return (
                <Navigate
                    to={`/${ROUTE_PATHS.apcmDashboard}`}
                    state={{ from: location }}
                    replace
                />
            );
        }
    } else {
        if(location?.pathname.includes('groupid') || location?.pathname.includes('executorLogsByID')) {
            return (
                <Navigate
                    to={`/${ROUTE_PATHS.apcmDashboard}`}
                    state={{ from: location }}
                    replace
                />
            );
        }
    }


    return children;
}
